import { db, auth } from "../utils/firebase";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import LogOutButton from "./LogOutButton";
import { useNavigate } from "react-router-dom";
import { updateProfile, signInWithEmailAndPassword } from "firebase/auth";

export default function NonVerifiedMemberPage({ user }) {
  const {
    name: { given_name, family_name },
    userTypeName,
    community,
    email_address,
    password,
    postal_code,
    city,
    street,
    country,
    region,
  } = user;

  const [newGivenName, setNewGivenName] = useState(given_name);
  const [newFamilyName, setNewFamilyName] = useState(family_name);

  const userCommunityChanger = doc(db, "Users", auth.currentUser.uid);
  const [newCommunity, setNewCommunity] = useState(community);
  const [detailsVis, setDetailsVis] = useState(true);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    async function changeCommunity() {
      await updateDoc(userCommunityChanger, { community: newCommunity });
    }
    changeCommunity();
  }, [newCommunity]);

  const updateUser = async () => {
    await updateDoc(userCommunityChanger, {
      name: {
        given_name: newGivenName,
        family_name: newFamilyName,
      },
    });
    setNewGivenName(newGivenName);
    setNewFamilyName(newFamilyName);
  };

  return (
    <div className="bg-user-home text-center detailsContainer">
      <h1>Dashboard</h1>

      <div className="container">
        <div className="row">
          <div className="col-12 col-md-4">
            <div id="myDetails" className="round-border">
              {editing ? (
                <>
                  <label>First Name:</label>
                  {"  "}
                  <input
                    type="text"
                    placeholder="First Name"
                    defaultValue={newGivenName}
                    onChange={(e) => setNewGivenName(e.target.value)}
                  />

                  <label>Last Name:</label>
                  {"  "}
                  <input
                    type="text"
                    placeholder="Last Name"
                    defaultValue={newFamilyName}
                    onChange={(e) => setNewFamilyName(e.target.value)}
                  />
                  <div>Role: {userTypeName}</div>
                  <div>Email: {email_address}</div>
                  <label>Address:</label>
                  <br />
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setEditing(!editing);
                      updateUser();
                    }}
                  >
                    Save
                  </button>
                </>
              ) : (
                <>
                  <div className="profileDetailsWrapper">
                    <div className="profileDetails">
                      <b>Name:</b> {newGivenName} {newFamilyName}
                    </div>
                    <div className="profileDetails">
                      <span>Role:</span>{" "}
                      <span className="alert alert-danger" role="alert">
                        Verification Pending
                      </span>
                    </div>
                    <div className="profileDetails">
                      <span>Email:</span> {email_address}
                    </div>

                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setEditing(!editing);
                      }}
                    >
                      Edit Info
                    </button>

                    <hr />

                    <button
                      type="button"
                      className="btn btn-primary button-md opacity-50 w-75 my-2"
                      id="startLinkIDV"
                      onClick={async () => {
                        try {
                          const data = await signInWithEmailAndPassword(
                            auth,
                            email_address,
                            password
                          );
                          console.log(data.user.accessToken);

                          // Replace with the URL of your deployed Google Cloud Function
                          const cloudFunctionURL =
                            "https://us-central1-vmf-dao.cloudfunctions.net/requestVerification";

                          const response = await fetch(cloudFunctionURL, {
                            method: "GET",
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: `Bearer ${data.user.accessToken}`,
                            },
                          });

                          console.log(response);
                          const result = await response.json();
                          console.log(result);

                          // Redirect the user to the Plaid verification URL
                          if (result.redirectUrl) {
                            window.open(result.redirectUrl, "_blank").focus();
                          }
                        } catch (error) {
                          console.error("Error:", error);
                        }
                      }}
                    >
                      Verify my identity
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="col-12 col-md-8">
            <h2>Your account is currently pending approval</h2>
            <p>Once you approved you will have access to Member features</p>
          </div>
        </div>
      </div>

      <LogOutButton />
    </div>
  );
}
